<template>
  <BasePageContainer>
    <SettingHeader>ノートテンプレートの管理</SettingHeader>
    <div class="pt-10 pb-4">
      <NoteTemplateForm
        v-if="initialized"
        :note-template="noteTemplate"
        :department-options="departmentOptions"
        :department-locked="departmentLocked"
        :response-errors="responseErrors"
        @submit="submit" />
    </div>
  </BasePageContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingHeader from '@/components/parts/SettingHeader.vue'
import NoteTemplateForm from '@/components/view/note_templates/NoteTemplateForm.vue'
import { PERMISSION_DENIED_MESSAGE } from '@/router/guard/permission'
import {
  canEditNoteTemplate,
  isDepartmentLocked,
  buildLockedDepartmentOptions,
  TEMPLATE_CHANGED_MESSAGE
} from '@/helper/noteTemplateDepartments'

export default {
  name: 'NoteTemplateEdit',
  components: {
    SettingHeader,
    NoteTemplateForm
  },
  data() {
    return {
      noteTemplate: null,
      responseErrors: {},
      initialized: false
    }
  },
  computed: {
    ...mapGetters('auth', ['accessibleDepartments']),
    noteTemplateId() {
      return this.$route.params.noteTemplateId
    },
    departmentLocked() {
      return isDepartmentLocked(this.noteTemplate)
    },
    // ロック中だけ、設定済みの権限外グループも並べて何が設定されているか読めるようにする
    departmentOptions() {
      return this.departmentLocked
        ? buildLockedDepartmentOptions(this.accessibleDepartments, this.noteTemplate)
        : this.accessibleDepartments
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.fetchNoteTemplate()
    this.$store.commit('finishLoading')
    if (!this.noteTemplate) return

    // 一覧で編集ボタンを隠すだけでは URL 直打ちを防げないため、ここでも判定する
    if (!canEditNoteTemplate(this.noteTemplate)) {
      this.$store.commit('notify/set', { message: PERMISSION_DENIED_MESSAGE })
      this.$router.push('/admin/note_templates/')
      return
    }
    this.initialized = true
  },
  methods: {
    fetchNoteTemplate() {
      return this.$axios.get(`/note_templates/${this.noteTemplateId}/`)
        .then(res => {
          this.noteTemplate = res.data
        })
        .catch(() => {
          this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
          this.$router.push('/admin/note_templates/')
        })
    },
    async submit(body) {
      this.$store.commit('startLoading')
      await this.$axios.patch(`/note_templates/${this.noteTemplateId}/`, body).then(res => {
        this.$store.commit('notify/set', { message: `${res.data.name}を保存しました。` })
        this.$router.push('/admin/note_templates/')
      }).catch(e => {
        console.error(e)
        // 編集不能になったテンプレートへの更新は API が 404 を返す（api#387）。
        // 開いている間に別のユーザーがグループを付け替えると起きるので、
        // この画面に留めても直しようがなく一覧へ戻す
        if (e.response?.status === 404) {
          this.$store.commit('notify/set', { message: TEMPLATE_CHANGED_MESSAGE, type: 'danger' })
          this.$router.push('/admin/note_templates/')
          return
        }
        this.responseErrors = e.response?.data || {}
        this.$store.commit('notify/set', { isUnknownError: true, type: 'danger' })
      })
      this.$store.commit('finishLoading')
    }
  }
}
</script>

<style scoped>
</style>
